// src/screens/yonetim/YonetimRaporlarScreen.js
import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { SafeAreaView } from 'react-native-safe-area-context';

export default function YonetimRaporlarScreen() {
  return (
    <SafeAreaView style={styles.safeArea} edges={['left', 'right', 'bottom']}>
      <View style={styles.center}>
        <Ionicons name="document-text-outline" size={64} color="#607D8B" />
        <Text style={styles.title}>Detaylı Raporlar</Text>
        <Text style={styles.sub}>Bu ekran henüz yapım aşamasında.</Text>
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea: { flex: 1, backgroundColor: '#F5F7FA' },
  center:   { flex: 1, justifyContent: 'center', alignItems: 'center', padding: 32 },
  title:    { fontSize: 22, fontWeight: '700', color: '#2c3e50', marginTop: 16 },
  sub:      { fontSize: 15, color: '#95a5a6', marginTop: 8, textAlign: 'center' },
});